import React from "react";
import { X, Check } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

const problems = [
  "Scattered supplier messages across email, chat and calls",
  "Unclear or inconsistent product specifications",
  "Quotations that are difficult to compare side by side",
  "Sourcing and shipping handled in disconnected conversations",
];

const solutions = [
  "One coordinated thread for your entire requirement",
  "Specifications captured clearly before sourcing begins",
  "Options organized so they can be evaluated fairly",
  "Sourcing and logistics planning kept connected",
];

export default function ProblemSolution({ chapter = "02" }) {
  return (
    <section className="bg-alt border-y border-[#D9E0E4]" data-testid="problem-solution">
      <div className="container-page py-20 lg:py-28">
        <SectionHeading
          chapter={chapter}
          eyebrow="The problem"
          title="International buying should not feel like guesswork"
          intro="Cross-border sourcing often turns into a maze of messages and mismatched details. We bring structure to the process."
        />
        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <Reveal className="bg-white border border-[#D9E0E4] rounded-lg p-7 lg:p-9">
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-[#B42318] mb-6">Without coordination</p>
            <ul className="space-y-4">
              {problems.map((p) => (
                <li key={p} className="flex gap-3 text-[15px] text-navy">
                  <span className="h-6 w-6 rounded-full bg-[#FBEBEA] flex items-center justify-center shrink-0">
                    <X className="h-3.5 w-3.5 text-[#B42318]" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="bg-navy rounded-lg p-7 lg:p-9 text-white">
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-copper mb-6">With Premier Global Sourcing</p>
            <ul className="space-y-4">
              {solutions.map((s) => (
                <li key={s} className="flex gap-3 text-[15px] text-white/90">
                  <span className="h-6 w-6 rounded-full bg-teal/25 flex items-center justify-center shrink-0">
                    <Check className="h-3.5 w-3.5 text-[#4FD1CA]" />
                  </span>
                  {s}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
